import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PlayerSignupForm from '../components/PlayerSignupForm';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Alert
} from '@mui/material';

const SignupPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    password: '',
    phone_number: '',
    birthday: ''
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const [qrCode, setQrCode] = useState(null);
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess('');
    setQrCode(null);

    try {
      const registerResponse = await fetch('http://localhost:8000/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify({
          ...formData,
          role: 'athlete'
        })
      });

      if (!registerResponse.ok) {
        const data = await registerResponse.json();
        throw new Error(data.detail || 'Signup failed');
      }

      const loginResponse = await fetch('http://localhost:8000/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify({
          email: formData.email,
          password: formData.password
        })
      });

      const loginData = await loginResponse.json();
      if (!loginResponse.ok) {
        throw new Error(loginData.detail || 'Login failed after signup');
      }

      const token = loginData.access_token;

      const qrRes = await fetch('http://localhost:8000/2fa/qr-code', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!qrRes.ok) {
        const contentType = qrRes.headers.get('content-type') || '';
        const errorMsg = contentType.includes('application/json')
          ? (await qrRes.json()).detail || 'QR code fetch failed'
          : await qrRes.text();

        throw new Error(`QR fetch failed: ${errorMsg}`);
      }

      const arrayBuffer = await qrRes.arrayBuffer();
      const base64String = btoa(
        new Uint8Array(arrayBuffer).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ''
        )
      );

      setQrCode(`data:image/png;base64,${base64String}`);
      console.log("QR code success message trigggered");
      setSuccess(
        '✅ Registration successful! 📱 Open your Google Authenticator app and scan the QR code below to complete setup. ' +
        'This will let you log in using your 6-digit 2FA code next time.'
      );
      


    } catch (err) {
      console.error(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  console.log("Success state value:", success);

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 8 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>
          Create Athlete Account
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
            required
            sx={{ mb: 2 }}
          />
          <TextField
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            fullWidth
            required
            sx={{ mb: 2 }}
          />
          <TextField
            label="Password"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            fullWidth
            required
            sx={{ mb: 2 }}
          />
          <TextField
            label="Phone Number"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Birthday"
            name="birthday"
            type="date"
            value={formData.birthday}
            onChange={handleChange}
            fullWidth
            InputLabelProps={{ shrink: true }}
            sx={{ mb: 3 }}
          />

          <Button type="submit" variant="contained" fullWidth disabled={loading}>
            {loading ? 'Creating...' : 'Create Account'}
          </Button>
          {typeof success === 'string' && success.length > 0 && (
            <Alert severity="success" sx={{ mt: 2 }}>
            {success}
            </Alert>
          )}

          {qrCode && (
            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <img src={qrCode} alt="2FA QR Code" style={{ maxWidth: '100%' }} />
            </Box>
          )}
        </form>
      </Paper>
    </Box>
  );
};

export default SignupPage;
